//remoteOperations = ServerSideProcessing

//#region import

import { AccessGuids, ConfigSystemParamDefaults, ConfigSystemParams, DgExportFormat, DgFormValidationRule, DxIcon, msSize, OurColors } from '../../consts';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../services/auth.service';
import { catchError, lastValueFrom, Subscription, throwError } from 'rxjs';
import { ComponentAccessUserService } from '../../services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from '../../services/utelize/system/config-system/config-system-service';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { DatePrecisionService } from '../../services/utelize/system/date-precision/date-precision-service';
import { DgActionColumn } from '../../interfaces/datagrid/dg-action-column';
import { DgAdditionalFilters, DgAdditionalFilters_EmptyObject } from '../../interfaces/datagrid/dg-additional-filters';
import { DgApiPath } from '../../interfaces/datagrid/dg-api-paths';
import { DgCellIcon, DgColumn, DgColumnValidation } from '../../interfaces/datagrid/dg-column';
import { DgPopup } from '../../interfaces/datagrid/dg-pop-up';
import { DgProperties } from '../../interfaces/datagrid/dg-properties';
import { DgTab } from '../../interfaces/datagrid/dg-tab';
import { DomSanitizer } from '@angular/platform-browser';
import { DxDataGridComponent } from 'devextreme-angular';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { eDatePrecision } from '../../enums';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../../services/utelize/general/exceptions-service';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { ExportingEvent } from 'devextreme/ui/data_grid';
import { formatDate } from '@angular/common';
import { FormControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { GlobalEventService } from '../../services/utelize/general/global-event-service';
import { GridColumnState } from '../../interfaces/datagrid/grid-column-state';
import { GridColumnStateService } from '../../services/utelize/general/grid-column-state-service';
import { GridViewService } from '../../services/utelize/general/grid-view.service';
import { HttpClientService } from '../../services/utelize/general/http-client-service';
import { HttpParams } from '@angular/common/http';
import { jsPDF } from 'jspdf';
import { LoadOptions } from 'devextreme/data';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { populateOurDate } from '../../functions-generic/functions-generic-date';
import { saveAs } from 'file-saver';
import { StorageService } from '../../services/utelize/general/storage-service';
import { SystemUserDTO } from '../../models/system/user/system-user.dto';
import { Workbook } from 'exceljs';

//#endregion

@Component({
  selector: 'app-grid-view',
  templateUrl: './grid-view.component.html',
  styleUrls: ['./grid-view.component.scss'],
  //providers: [GridViewService]
})

export class GridViewComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() apiPath             : DgApiPath         | undefined;
  @Input() autoLoad            : boolean = true; 
  @Input() continuousLoadPanel : boolean = true;
  @Input() dgActionColumn      : DgActionColumn    | undefined;
  @Input() dgPopup             : DgPopup           | undefined;
  @Input() dgProperties        : DgProperties      | undefined;
  @Input() dgTabs              : Array<DgTab>      | undefined;
  @Input() injectedModal       : TemplateRef<void> | undefined;
  @Input() showCeasedFilters   : boolean = false;
  @Input() showDeletedToggle   : boolean = false;
  @Input() toolbarStartTemplate: TemplateRef<any>  | undefined;

  //#region @Input() set dgColumns

  @Input() set dgColumns(value: Array<DgColumn> | undefined) {
    value?.forEach(col => {
      if (!col.customizeText && (col.dataType==='date' || col.dataType==='datetime')) {
        const fmt=col.dataType==='datetime' ? 'dd/MM/yyyy HH:mm:ss' : 'dd/MM/yyyy';

        col.customizeText=(args: any) => {
          if (args.target==='headerFilter' || args.target==='filterRow' || args.target==='filterBuilder')
            return args.valueText ?? '';

          return args.value
                 ? formatDate(args.value, col.datePrecisionParam
                              ? this.datePrecisionService.getDisplayFormat(col.datePrecisionParam, this.datePrecisionDefault(col.datePrecisionParam))
                              : fmt, 'en-GB', col.datePrecisionParam ? undefined : 'UTC')
                 : '';
        };
      }

      if (col.datePrecisionParam && !col.headerFilter && (col.dataType==='date' || col.dataType==='datetime')) {
        const precision=this.datePrecisionService.getPrecision(col.datePrecisionParam, this.datePrecisionDefault(col.datePrecisionParam));

        if (precision===eDatePrecision.MonthYear)
          col.headerFilter={ groupInterval: 'month' };
        else if (precision===eDatePrecision.Year)
          col.headerFilter={ groupInterval: 'year' };
      }
    });
    this._dgColumns=value;
  }

  //#endregion

  @Output() additionalFiltersChange: EventEmitter<DgAdditionalFilters      >=new EventEmitter<DgAdditionalFilters      >();
  @Output() addButtonClick         : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() cellClick              : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() checkbox0Change        : EventEmitter<boolean | number | string>=new EventEmitter<boolean | number | string>();
  @Output() checkbox1Change        : EventEmitter<boolean | number | string>=new EventEmitter<boolean | number | string>();
  @Output() contentReady           : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() dataHasBeenDeleted     : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() dataHasBeenSaved       : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() deleteButtonClick      : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() dropdownChanged        : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() editButtonClick        : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() locationButtonClick    : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() messageButtonClick     : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() moreButtonClick        : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() refreshClick           : EventEmitter<number                   >=new EventEmitter<number                   >();
  @Output() riskButtonClick        : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() rowClick               : EventEmitter<number                   >=new EventEmitter<number                   >();
  @Output() rowDblClick            : EventEmitter<number                   >=new EventEmitter<number                   >();
  @Output() rowEditStarted         : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() rowExpanding           : EventEmitter<number                   >=new EventEmitter<number                   >();
  @Output() rowRightClick          : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() selectionChanged       : EventEmitter<any[]                    >=new EventEmitter<any[]                    >();
  @Output() statementButtonClick   : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() tabChanged             : EventEmitter<any                      >=new EventEmitter<any                      >();
  @Output() undeleteButtonClick    : EventEmitter<any                      >=new EventEmitter<any                      >();

  @ViewChild(DxDataGridComponent,   { static: false }) dataGrid!            : DxDataGridComponent;
  @ViewChild('deleteModel',         { static: false }) deleteModalTemplate! : TemplateRef<void>;
  @ViewChild('genericModalContent', { static: false }) genericModalTemplate!: TemplateRef<void>;
  get dgColumns(): Array<DgColumn> | undefined { return this._dgColumns; }

  get additionalFiltersActive() { return this.additionalFilters.includeCeased
                                         || this.additionalFilters.includeDeleted
                                         || this.additionalFilters.onlyCeased
                                         || this.additionalFilters.onlyDeleted
                                         || this.includeCeasedChecked                                                  ; }
  get hasAdditionalFilters   () { return this.showCeasedFilters
                                         || this.showDeletedToggle
                                         || this.dgProperties?.checkbox1?.visible===true                               ; }
  get gridViewModernStyle    () { return document.body.classList.contains("grid-view-modern")                          ; }
  get includeCeasedChecked   () { return this.dgProperties?.checkbox1?.visible===true
                                         && this.dgProperties?.checkbox1?.value===this.dgProperties?.checkbox1?.onValue; }

  get gridRememberColumns(): boolean {
    try {
      return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridRememberColumns, false)
             && (this.dgProperties?.rememberColumns ?? true )
             && (this.dgProperties?.columnChooser   ?? false)
             && (this.dgProperties?.gridKey         ?? ""   ).length>0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }

  get gridAllowCopyCellValue  () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridCopyCellValueToClipboard,    true ); }
  get gridButtonsOnHoverGrow  () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridButtonsOnHoverGrow,          true ); }
  get gridColumnChooserSort   () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridColumnChooserItemsSortAlpha, false); }
  get gridShowButtons         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowButtons,                 true ); }
  get gridSureSimBlue         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridSureSimBlue,                 false); }
  get modalSearchableDropdowns() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridModalDropdownsSearchable,    true ); }
  get showTooltips            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowTooltips,                    false); }
  get titlesUseSureSimBlue    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesTitlesUseSureSimBlue,       false); }

  get gridRowClickTimerMilliSecs() { return this.configSystemService.getValueAsInteger(ConfigSystemParams.GridRowClickTimerMilliSecs, 250 ); }

  get gridSearchPanelWidthPx() {
    try {
      const configured: number=this.configSystemService.getValueAsInteger(ConfigSystemParams.GridSearchPanelWidthPx, 0);
      return configured>0 ? configured : 200;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 200;
    }
  }
    
  private _dgColumns             : Array<DgColumn>   | undefined;
  private accessGuidsChangedSub  : Subscription | undefined;
  private additionalFiltersTarget: HTMLElement | null=null;
  private addNewRecord           : boolean=false;
  private anyDbObject!           : any;
  private avatarPhotoUrlCache    : Map<string, string>=new Map<string, string>();
  private clientLoadSub          : Subscription | undefined;   //RBW_20260622 - in-flight client-side load; cancelled when a newer load starts (prevents stale-response race)
  private deleteRowData          : any;
  private gridInstance           : any;
  private hasColouredRow         : boolean=false;
  private loadPanelActive        : boolean=false;
  private loadPanelSafetyTimer   : any;
  private modalTemplate!         : TemplateRef<void>;
  private modalTemplateRef!      : NgbModalRef;
  private pendingDimensionsFix   : boolean=false;
  private persistedColumns       : Map<string, string | null>=new Map<string, string | null>();
  private rowClickTimer          : ReturnType<typeof setTimeout> | null=null;
  private stickyHeightApplied    : boolean=false;
  private viewportFitFrame       : number | null=null;
  private viewportFitMutation    : MutationObserver | undefined;
  private viewportFitObserver    : ResizeObserver | undefined;
  private viewportFitUnlisten    : (() => void) | undefined;

  private static readonly filterRowStorageKeyPrefix: string="gridFilterRowVisible:";
  private static          modernMountCount         : number=0;

  public activeId                    : any;
  public additionalFilters           : DgAdditionalFilters=DgAdditionalFilters_EmptyObject();
  public additionalFiltersPosition   : any;
  public additionalFiltersVisible    : boolean=false;
  public additionalFiltersWrapperAttr: { class: string }={ class: 'gv-additional-filters' };

  public readonly additionalFiltersHideOnOutsideClick=(e: any): boolean => {
    try {
      return !(this.additionalFiltersTarget?.contains(<Node>e?.target) ?? false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  };
  public addOrEditForm!            : UntypedFormGroup;
  public allFetchedModels          : any[]=[];
  public clientSideProcessingModels: any[]=[];
  public curUser                   : SystemUserDTO;
  public deleteId                  : any;
  public displayHtml               : boolean=false;
  public dxoPopupButtonItems       : any;
  public filterRowVisible          : boolean=false;
  public formSubmitted             : boolean=false;
  public isPlatformModeInview      : boolean=environment.platformModeInview;
  public isUserDefinedColumns      : boolean=false;
  public selectionChangedRaised    : boolean=false;
  public serverSideDataSource!     : DataSource;
  //public scssUrl                   : string="grid-view.component-sticky-headers.scss";
  
  constructor(
    private authenticationService     : AuthenticationService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private datePrecisionService      : DatePrecisionService,
    private elementRef                : ElementRef,
    private exceptionsService         : ExceptionsService,
    private formBuilder               : UntypedFormBuilder,
    private globalEventService        : GlobalEventService,
    private gridColumnStateService    : GridColumnStateService,
    private gridViewService           : GridViewService,
    private httpClientService         : HttpClientService,
    private modalService              : NgbModal,
    private ngZone                    : NgZone,
    private renderer2                 : Renderer2,
    private storageService            : StorageService,

    public sanitizer: DomSanitizer
  ) {
    this.curUser=this.authenticationService.currentUserObject();
    try {
      // this.gridViewService.fireEvent$.subscribe({
      //   next: data => {
      //     this._refreshData();
      //   },
      //   error: error => {
      //     this.exceptionsService.handleException(new Error(error));
      //   }
      // });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnInit(): void {
    try {
      if (this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridViewModernStyle, false)) {
        if (GridViewComponent.modernMountCount==0)
          this.renderer2.addClass(document.body, "grid-view-modern");

        GridViewComponent.modernMountCount++;
      }

      if (this.checkInjectedData()) {
        this.displayHtml          =true;
        this.filterRowVisible     =this.resolveDefaultFilterRowVisible();
        this.accessGuidsChangedSub=this.globalEventService.accessGuidsChanged$.subscribe({
          next : () => { this.applyAccessGuidDefault();                                       },
          error: err => { this.exceptionsService.handleException(new Error(<string><unknown>err)); }
        });

        this.gridViewService.apiMethodOverrideGet=this.dgProperties?.apiMethodOverrideGet;
        this.gridViewService.apiPathDelete       =this.apiPath?.delete;
        this.gridViewService.apiPathGet          =this.apiPath?.get;
        this.gridViewService.apiPathPost         =this.apiPath?.post;
        this.gridViewService.apiPathPut          =this.apiPath?.put;
        this.gridViewService.dgColumns           =this.dgColumns;
        this.gridViewService.dgTabs              =this.dgTabs;
        // this.gridViewService.encryptDelete       =this.dgProperties?.encryptDelete;
        this.gridViewService.encryptDeleteSS     =this.dgProperties?.encryptDeleteSS;
        this.gridViewService.encryptPost         =this.dgProperties?.encryptPost;
        this.gridViewService.encryptPut          =this.dgProperties?.encryptPut;

        this.gridViewService.validateApiPaths();

        if (!this.dgProperties!.useDevExtremePopupForm)
          this.setupNonDevExtremeForm();

        this.activeId = this.dgProperties?.initialTab;

        if (this.autoLoad) {
          if (this.dgProperties?.remoteOperations) {
            this.clientSideProcessingModels=[];
            this.setupServerSideProcessingStore();
          } else {
            this.getDataForClientSideProcessing();
          }
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(): void {
    try {
      if (!this.dgProperties!.useDevExtremePopupForm) {
        this.modalTemplate = this.injectedModal==undefined ? this.genericModalTemplate : this.injectedModal;
      }

      this.startViewportFit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.accessGuidsChangedSub?.unsubscribe();
      this.clientLoadSub?.unsubscribe();
      this.stopViewportFit();

      this.avatarPhotoUrlCache.forEach(url => {
                                                if (url.startsWith("blob:"))
                                                  URL.revokeObjectURL(url);
                                      });
      this.avatarPhotoUrlCache.clear();

      if (GridViewComponent.modernMountCount>0) {
        GridViewComponent.modernMountCount--;

        if (GridViewComponent.modernMountCount==0)
          this.renderer2.removeClass(document.body, "grid-view-modern");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private resolveDefaultFilterRowVisible(): boolean {
    try {
      const stored=this.storageService.getItem(this.getFilterRowStorageKey());

      if (stored==="true" || stored==="false")
        return stored==="true";

      return this.componentAccessUserService.hasAccessGuid(AccessGuids.GridShowFiltersByDefault, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private applyAccessGuidDefault(): void {
    try {
      const stored=this.storageService.getItem(this.getFilterRowStorageKey());

      if (stored==="true" || stored==="false")
        return;

      const next=this.componentAccessUserService.hasAccessGuid(AccessGuids.GridShowFiltersByDefault, true);

      if (next===this.filterRowVisible)
        return;

      this.filterRowVisible=next;

      const gridInstance=this.dataGrid?.instance;

      if (gridInstance) {
        gridInstance.option('filterRow.visible', this.filterRowVisible);

        if (this.dgProperties?.headerFilter)
          gridInstance.option('headerFilter.visible', this.filterRowVisible);

        gridInstance.repaint();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getFilterRowStorageKey(): string {
    try {
      return GridViewComponent.filterRowStorageKeyPrefix+window.location.pathname;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return GridViewComponent.filterRowStorageKeyPrefix;
    }
  }

  public additionalFiltersCheckbox1Changed(e: any): void {
    try {
      if (e?.event==undefined)
        return;

      this.checkbox1Change.emit(e.value===true ? this.dgProperties?.checkbox1?.onValue : this.dgProperties?.checkbox1?.offValue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public additionalFilterChanged(key: keyof DgAdditionalFilters, e: any): void {
    try {
      if (e?.event==undefined || this.additionalFilters[key]===(e.value===true))
        return;

      this.additionalFilters={ ...this.additionalFilters, [key]: e.value===true };

      this.additionalFiltersChange.emit({ ...this.additionalFilters });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openAdditionalFilters(target: EventTarget | null): void {
    try {
      this.additionalFiltersTarget  =<HTMLElement | null>target;
      this.additionalFiltersPosition={ at: 'right bottom', my: 'right top', of: target, offset: '0 4' };
      this.additionalFiltersVisible =!this.additionalFiltersVisible;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleFilterRow(): void {
    try {
      this.filterRowVisible=!this.filterRowVisible;
      this.storageService.setItem(this.getFilterRowStorageKey(), this.filterRowVisible ? "true" : "false");

      const gridInstance=this.dataGrid?.instance;

      if (gridInstance) {
        gridInstance.option('filterRow.visible', this.filterRowVisible);

        if (this.dgProperties?.headerFilter)
          gridInstance.option('headerFilter.visible', this.filterRowVisible);

        gridInstance.repaint();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Column memory

  private applyDefaultColumnVisibility(): void {
    try {
      const instance=this.dataGrid?.instance;

      if (!instance)
        return;

      instance.beginUpdate();

      try {
        let index=0;

        for (const col of (this.dgColumns ?? [])) {
          if (col.dataField!=undefined) {
            instance.columnOption(col.dataField, 'visible',      col.gridVisible!==false);
            instance.columnOption(col.dataField, 'visibleIndex', index++);
            instance.columnOption(col.dataField, 'sortOrder',    col.sortOrder);
            instance.columnOption(col.dataField, 'sortIndex',    col.sortIndex);
          }
        }
      }
      finally {
        instance.endUpdate();
      }

      this.isUserDefinedColumns=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildStateFromColumns(savedColumns: GridColumnState[]): any {
    try {
      const savedFields  =savedColumns.map(c => c.field);
      const visibleFields=savedColumns.filter(c => c.sortOnly!==true).map(c => c.field);
      let   nextIndex    =visibleFields.length;
      const unsortable   =(this.dgColumns ?? []).filter(col => col.allowSorting===false).map(col => col.dataField);
      const savedHasSort =savedColumns.some(c => (c.sortOrder==="asc" || c.sortOrder==="desc") && !unsortable.includes(c.field));

      const columns=(this.dgColumns ?? [])
                    .filter(col => col.dataField!=undefined)
                    .map(col => {
                      const savedIndex  =savedFields.indexOf(col.dataField);
                      const saved       =savedIndex>-1 ? savedColumns[savedIndex] : undefined;
                      const visibleIndex=visibleFields.indexOf(col.dataField);
                      const isVisible   =visibleIndex>-1;
                      const canSort     =col.allowSorting!==false;

                      return {
                        dataField   : col.dataField,
                        sortIndex   : !canSort
                                      ? undefined
                                      : savedHasSort
                                        ? (saved?.sortOrder!=undefined ? (saved.sortIndex ?? 0) : undefined)
                                        : col.sortIndex,
                        sortOrder   : !canSort ? undefined : (savedHasSort ? saved?.sortOrder : col.sortOrder),
                        visible     : isVisible,
                        visibleIndex: isVisible ? visibleIndex : nextIndex++
                      };
                    });

      return { columns: columns };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private evaluateUserDefinedColumns(): void {
    try {
      if (!this.gridRememberColumns) {
        this.isUserDefinedColumns=false;
        return;
      }

      const instance=this.dataGrid?.instance;

      if (!instance) {
        this.isUserDefinedColumns=false;
        return;
      }

      const defaultVisible: string[]=(this.dgColumns ?? [])
                                     .filter(col => col.dataField!=undefined && col.gridVisible!==false)
                                     .map   (col => col.dataField);

      const defaultSort=(this.dgColumns ?? [])
                        .filter(col => col.dataField!=undefined && (col.sortOrder==="asc" || col.sortOrder==="desc"))
                        .sort  ((a, b) => (a.sortIndex ?? 0) - (b.sortIndex ?? 0))
                        .map   (col => col.dataField + ":" + col.sortOrder)
                        .join  (",");

      const colCount       =instance.columnCount();
      const currentColumns : Array<{ dataField: string; visibleIndex: number }>=[];
      const currentSortCols: Array<{ dataField: string; sortIndex: number; sortOrder: string }>=[];

      for (let i=0; i<colCount; i++) {
        const dataField=<string | undefined>instance.columnOption(i, 'dataField');

        if (dataField==undefined)
          continue;

        if (instance.columnOption(i, 'visible')!==false)
          currentColumns.push({ dataField: dataField, visibleIndex: <number>(instance.columnOption(i, 'visibleIndex') ?? i) });

        const sortOrder=<string | undefined>instance.columnOption(i, 'sortOrder');

        if (sortOrder==="asc" || sortOrder==="desc")
          currentSortCols.push({ dataField: dataField, sortIndex: <number>(instance.columnOption(i, 'sortIndex') ?? 0), sortOrder: sortOrder });
      }

      const currentVisible=currentColumns
                           .sort((a, b) => a.visibleIndex - b.visibleIndex)
                           .map (c => c.dataField);

      const currentSort=currentSortCols
                        .sort((a, b) => a.sortIndex - b.sortIndex)
                        .map (c => c.dataField + ":" + c.sortOrder)
                        .join(",");

      const sameOrder=defaultVisible.length===currentVisible.length
                      && defaultVisible.every((f, i) => f===currentVisible[i]);

      const sameSort=defaultSort===currentSort;

      this.isUserDefinedColumns=!sameOrder || !sameSort;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      this.isUserDefinedColumns=false;
    }
  }

  public restoreColumns(): void {
    try {
      if (!this.gridRememberColumns)
        return;

      const gridKey: string=this.dgProperties!.gridKey!;

      this.gridColumnStateService.reset(gridKey)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next : () => {
          this.persistedColumns.set(gridKey, null);
          this.applyDefaultColumnVisibility();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public stateStoringLoad=(): Promise<any> => {
    try {
      if (!this.gridRememberColumns)
        return Promise.resolve(undefined);

      const gridKey: string=this.dgProperties!.gridKey!;

      return lastValueFrom(this.gridColumnStateService.get(gridKey))
             .then(savedColumns => {
               if (!Array.isArray(savedColumns) || savedColumns.length===0) {
                 this.persistedColumns.set(gridKey, null);
                 return undefined;
               }

               this.persistedColumns.set(gridKey, JSON.stringify(savedColumns));
               return this.buildStateFromColumns(savedColumns);
             })
             .catch(error => {
               this.persistedColumns.delete(gridKey);
               this.exceptionsService.handleException(new Error(this.exceptionsService.formatHttpError(error)));
               return undefined;
             });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return Promise.resolve(undefined);
    }
  };

  public stateStoringSave=(state: any): void => {
    try {
      if (!this.gridRememberColumns)
        return;

      const isSorted=(c: any): boolean => c?.sortOrder==="asc" || c?.sortOrder==="desc";

      const columns: GridColumnState[]=(state?.columns ?? [])
                                       .filter((c: any) => c?.dataField!=undefined && (c.visible!==false || isSorted(c)))
                                       .sort  ((a: any, b: any) => (a.visibleIndex ?? 0) - (b.visibleIndex ?? 0))
                                       .map   ((c: any) => {
                                         const column: GridColumnState={ field: <string>c.dataField };

                                         if (c.visible===false)
                                           column.sortOnly=true;

                                         if (isSorted(c)) {
                                           column.sortOrder=c.sortOrder;
                                           column.sortIndex=c.sortIndex ?? 0;
                                         }

                                         return column;
                                       });

      this.evaluateUserDefinedColumns();

      const gridKey    : string       =this.dgProperties!.gridKey!;
      const columnsJson: string | null=this.isUserDefinedColumns ? JSON.stringify(columns) : null;

      if (this.persistedColumns.has(gridKey) && this.persistedColumns.get(gridKey)===columnsJson)
        return;

      const request$=this.isUserDefinedColumns
                     ? this.gridColumnStateService.save(gridKey, columns)
                     : this.gridColumnStateService.reset(gridKey);

      request$
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next : ()    => { this.persistedColumns.set(gridKey, columnsJson); },
        error: error => { this.exceptionsService.handleException(new Error(error)); }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  };

  //#endregion

  private applyStickyGridHeaders(): void {
    try {
      const headerPanel=this.elementRef.nativeElement.querySelector('.dx-datagrid-header-panel') as HTMLElement | null;
      const headers    =this.elementRef.nativeElement.querySelector('.dx-datagrid-headers')      as HTMLElement | null;

      if (this.gridViewModernStyle) {
        if (headerPanel) {
          headerPanel.style.position  ='';
          headerPanel.style.top       ='';
          headerPanel.style.zIndex    ='';
          headerPanel.style.paddingTop='';
        }

        if (headers) {
          headers.style.position='';
          headers.style.top     ='';
          headers.style.zIndex  ='';
        }

        return;
      }

      if (this.elementRef.nativeElement.closest('.grid-scroll-wrapper-wide')) {
        
        if (headerPanel) {
          headerPanel.style.position  ='';
          headerPanel.style.top       ='';
          headerPanel.style.zIndex    ='';
          headerPanel.style.paddingTop='';
        }
        if (headers) {
          headers.style.position='';
          headers.style.top     ='';
          headers.style.zIndex  ='';
        }
        return;
      }

      const pageContent      =this.elementRef.nativeElement.closest('.page-content')  as HTMLElement | null;
      const stickyHeader     =pageContent?.querySelector('.page-sticky-header')       as HTMLElement | null;
      const stickyHeaderTop  =stickyHeader
                               ? parseFloat(getComputedStyle(stickyHeader).top) || 70
                               : parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ss-topbar-total-height') || '70');
      const fixedHeaderHeight=stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
      const shadowGap        =0;
      const fixedHeaderBottom=stickyHeaderTop + fixedHeaderHeight + shadowGap;
      const toolbarContent   =headerPanel?.querySelector('.dx-toolbar') as HTMLElement | null;
      const toolbarHeight    =toolbarContent ? toolbarContent.getBoundingClientRect().height : (headerPanel?.getBoundingClientRect().height ?? 0);

      if (headerPanel) {
        headerPanel.style.position  ='sticky';
        headerPanel.style.top       =fixedHeaderBottom+'px';
        headerPanel.style.zIndex    ='110';
        headerPanel.style.paddingTop='0px';
      }

      if (headers) {
        headers.style.position='sticky';
        headers.style.top     =(fixedHeaderBottom + toolbarHeight)+'px';
        headers.style.zIndex  ='110';
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private startViewportFit(): void {
    try {
      if (this.dgProperties?.skipStickyLayout || this.dgProperties?.height!=undefined || typeof ResizeObserver==='undefined')
        return;

      const host  =<HTMLElement>this.elementRef.nativeElement;
      const target=<HTMLElement>(host.closest('.page-content') ?? document.body);

      this.ngZone.runOutsideAngular(() => {
        this.viewportFitMutation=new MutationObserver(mutations => {
          if (mutations.some(m => !host.contains(m.target)))
            this.scheduleViewportFit();
        });
        this.viewportFitMutation.observe(target, { childList: true, subtree: true });

        this.viewportFitObserver=new ResizeObserver(() => this.scheduleViewportFit());
        this.viewportFitObserver.observe(target);
        this.viewportFitUnlisten=this.renderer2.listen('window', 'resize', () => this.scheduleViewportFit());
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private scheduleViewportFit(): void {
    try {
      if (this.viewportFitFrame!=null)
        return;

      this.viewportFitFrame=requestAnimationFrame(() => {
        try {
          this.viewportFitFrame=null;

          if ((<HTMLElement>this.elementRef.nativeElement).offsetParent===null)
            return;

          this.applyStickyGridPager();
        }
        catch(e) {
          this.exceptionsService.handleException(<Error>e);
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private stopViewportFit(): void {
    try {
      this.viewportFitMutation?.disconnect();
      this.viewportFitMutation=undefined;
      this.viewportFitObserver?.disconnect();
      this.viewportFitObserver=undefined;
      this.viewportFitUnlisten?.();
      this.viewportFitUnlisten=undefined;

      if (this.viewportFitFrame!=null) {
        cancelAnimationFrame(this.viewportFitFrame);
        this.viewportFitFrame=null;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public applyStickyGridPager(): void {
    try {
      //CRN_20260429 - Explicit height - no viewport-fill override
      if (this.dgProperties?.height != undefined)
        return;

      const isWide         =!!this.elementRef.nativeElement.closest('.grid-scroll-wrapper-wide');
      const gridEl         =this.elementRef.nativeElement.querySelector('.dx-datagrid') as HTMLElement | null;
      const footer         =document.querySelector('footer.footer')                     as HTMLElement | null;
      const footerHeight   =isWide ? 0 : (footer ? footer.getBoundingClientRect().height : 40);
      const scrollTop      =window.scrollY || document.documentElement.scrollTop || 0;
      const gridTop        =gridEl ? gridEl.getBoundingClientRect().top + scrollTop : 0;
      const availableHeight=window.innerHeight-gridTop-footerHeight-4;

      if (!this.dataGrid?.instance)
        return;

      if (availableHeight>100) {
        if (this.dataGrid.instance.option('height')!==availableHeight) {
          this.dataGrid.instance.option('height', availableHeight);
        }

        this.stickyHeightApplied=true;
      }
      else if (this.stickyHeightApplied) {
        this.dataGrid.instance.option('height', undefined);
        this.stickyHeightApplied=false;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private checkInjectedData(): boolean {
    try {
      if (!this.apiPath)
        throw new Error("Grid-View: API Path not set");

      if (!this.dgActionColumn)
        throw new Error("Grid-View: Action Column not set");

      if (!this.dgColumns)
        throw new Error("Grid-View: Columns not set");

      if (!this.dgPopup)
        throw new Error("Grid-View: Popup not set");

      if (!this.dgProperties)
        throw new Error("Grid-View: Properties not set");

      return true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //This relies on currencySymbol and cost columns existing in data
  // public displayCurrency = (data: any) => {
  //   return `${data.currencySymbol}${data.cost}`; 
  // }
  public dataCheck = (fieldToCheck: string | undefined, valuesToCheckAgainst: string[] | undefined, data: any) => {
    try {
      if (fieldToCheck == undefined || valuesToCheckAgainst == undefined) {
        return true
      }
      let value  = JSON.stringify(data.data[fieldToCheck]);
      let result = valuesToCheckAgainst.includes(value); 
      if (!result && valuesToCheckAgainst.includes("Positive")) {
        result = Number(value) > 0;
      }
      if (!result && valuesToCheckAgainst.includes("Negative")) {
        result = Number(value) < 0;
      }
      return result;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public getCellIcon=(column: DgColumn, rowData: any): DgCellIcon | undefined => {
    try {
      return column.cellIcon==undefined ? undefined : column.cellIcon(rowData);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public getImage = (data: any, column: string | undefined) => {
    try {
      let image = "";
      let col   = column ?? "";
      if (col.indexOf('.') > -1) {
        var propertyToLookFor = column?.substring(0,column?.indexOf('.'));
        var continueLookingFor = column?.substring(column?.indexOf('.') +1, column?.length)
        Object.entries(data).forEach(([key, value]) => {
          if (key === propertyToLookFor) {
            image = this.getImage(value,continueLookingFor);
          }
        });
      } else {
        Object.entries(data).forEach(([key, value]) => {
          if (key === column) {
            image = <string>value;
          }
        });
      }
  
      return image;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public getInitials=(value: any): string => {
    try {
      const text=(<string>(value ?? "")).trim();

      if (text=="")
        return "?";

      const parts=text.split(/\s+/).filter(p => p.length>0);

      if (parts.length==1)
        return parts[0].substring(0, 2).toUpperCase();

      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "?";
    }
  }

  public getAvatarColor = (value: any): string => {
    try {
      const palette=["#5B6CB8", "#2FA39B", "#E89B3B", "#3F8F4F", "#8E6FC4", "#C45A8B", "#3E89C9", "#D1A33B", "#7A8290", "#2FB39A"];
      const text   =(<string>(value ?? "")).trim();

      let hash=0;

      for (let i=0; i<text.length; i++)
        hash=text.charCodeAt(i) + ((hash << 5) - hash);

      return palette[Math.abs(hash) % palette.length];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "#7A8290";
    }
  }

  public getAvatarPhotoObjectUrl=(rowData: any, column: DgColumn): string => {
    try {
      const urlField=column.photoUrlField;
      const photoUrl=urlField==undefined ? "" : (rowData?.[urlField] ?? "");

      if (photoUrl=="")
        return "";

      if (this.avatarPhotoUrlCache.has(photoUrl))
        return this.avatarPhotoUrlCache.get(photoUrl)!;

      this.avatarPhotoUrlCache.set(photoUrl, "");

      const relative=(<string>photoUrl).replace(/^\//, "").replace(/^api\//, "");
      const path    =(<string>photoUrl).startsWith("http") ? photoUrl : environment.eSimApi + relative;

      this.httpClientService.getBlob(path).subscribe({
        next : response => {
          this.avatarPhotoUrlCache.set(photoUrl, URL.createObjectURL(<Blob>response.body));
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });

      return this.avatarPhotoUrlCache.get(photoUrl)!;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public hasAvatarPhoto=(rowData: any, column: DgColumn): boolean => {
    try {
      const hasField=column.photoHasField;
      const urlField=column.photoUrlField;

      if (hasField==undefined || urlField==undefined)
        return false;

      return rowData?.[hasField]==true && (rowData?.[urlField] ?? "")!="";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //#region Data for Client or Server Side Processing

  private showContinuousLoadPanel() {
    try {
      if (!this.continuousLoadPanel)
        return;

      this.armLoadPanelSafetyTimer();

      if (this.loadPanelActive)
        return;

      const instance=this.gridInstance ?? this.dataGrid?.instance;

      if (!instance)
        return;

      this.loadPanelActive=true;
      instance.beginCustomLoading(this.dgProperties?.loadPanelText ?? "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private maybeHideContinuousLoadPanel(component: any) {
    try {
      if (!this.continuousLoadPanel || !this.loadPanelActive)
        return;

      const hasData=((component?.getVisibleRows?.() ?? []).length) > 0;

      if (hasData)
        this.hideContinuousLoadPanelNow();
      else
        this.armLoadPanelSafetyTimer();   //still empty: the inter-load "No data" gap, or a genuinely empty result
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private hideContinuousLoadPanelNow() {
    try {
      if (this.loadPanelSafetyTimer) {
        clearTimeout(this.loadPanelSafetyTimer);
        this.loadPanelSafetyTimer=undefined;
      }

      if (this.loadPanelActive) {
        this.loadPanelActive=false;
        (this.gridInstance ?? this.dataGrid?.instance)?.endCustomLoading();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //Force-hide fallback so a genuinely empty result (no data row ever arrives) doesn't leave the panel stuck.
  private armLoadPanelSafetyTimer() {
    try {
      if (this.loadPanelSafetyTimer)
        clearTimeout(this.loadPanelSafetyTimer);

      this.loadPanelSafetyTimer=setTimeout(() => this.hideContinuousLoadPanelNow(), 3000);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onGridInitialized(e: any) {
    try {
      this.gridInstance=e?.component;

      //RBW_20260618 - Show the continuous load panel as soon as the grid instance exists (before the first
      //               load). The CustomStore load callback can run before the dataGrid ViewChild is assigned,
      //               so beginCustomLoading there can be missed; onInitialized is the earliest reliable point.
      if (this.continuousLoadPanel) {
        //RBW_20260618 - Anchor the load panel to the TOP of the grid element so it doesn't re-centre (drift
        //               downward) as the grid grows from collapsed to full height during the load. Set
        //               imperatively because the declarative [position] binding isn't honoured for the panel.
        try {
          this.gridInstance?.option("loadPanel.position", { my: "top", at: "top", of: this.gridInstance.element(), offset: { x: 0, y: 80 } });
        }
        catch { }

        this.showContinuousLoadPanel();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async getDataForClientSideProcessing(): Promise<void> {
    try {
      //CRN_20260804 - Grids need signed token refresh
      await this.refreshApiPathGet();

      this.gridViewService.apiPathGet=this.apiPath?.get;
      //RBW_20260723 - Re-prime the GET override here too (not just at ngOnInit). GridViewService is a root singleton
      //shared by every grid, so when a screen hosts multiple grids the last one to init would otherwise leave a stale
      //override on the service. Re-priming per load ensures each grid uses its own apiMethodOverrideGet (e.g. the alert
      //devices grid, which POSTs its request body instead of using a query-string GET).
      this.gridViewService.apiMethodOverrideGet=this.dgProperties?.apiMethodOverrideGet;

      this.showContinuousLoadPanel();

      //RBW_20260622 - Cancel any in-flight client-side load before starting a new one.
      this.clientLoadSub?.unsubscribe();

      this.clientLoadSub=this.gridViewService.getClientSideProcessingModels()
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.allFetchedModels          =data;
          this.clientSideProcessingModels=this.applyShowOnlyView(data);
          this.dataGrid.instance.refresh();
        },
        error: error => {
          this.hideContinuousLoadPanelNow();

          if (this.dgProperties?.errorReplaceIf && error.message && error.message.includes(this.dgProperties?.errorReplaceIf)) {
            this.exceptionsService.handleException(new Error(this.dgProperties?.errorReplacement));

          } else if (this.dgProperties?.errorSuppressIf && error.message && error.message.includes(this.dgProperties?.errorSuppressIf)) {
            //do nothing

          } else {
            this.exceptionsService.handleException(new Error(error));
          }
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onImageClick(imageType:string, data: any): void {

    let e = {
      row: {
        data: data.data
      }
    };

    if (imageType=='updateButton')
    {
      if (this.dgPopup!.overridePopup) {
        this.editButtonClick.emit(e);
      } else {
        let rowData={...e.row!.data};
        this.openFormToEdit(rowData);
      }
    } else if (imageType=='deleteButton') {
      if (this.dgActionColumn!.overrideDelete) {
        this.deleteButtonClick.emit(e);
      } else {
        let rowData={...e.row!.data};
        this.confirmDelete(rowData);
      }
    } else if (imageType=='moreButton') {
      if (this.dgPopup!.overridePopup) {
        this.moreButtonClick.emit(e);
      } else {
        //Not Implemented
      }
    } else if (imageType=='riskButton') {
      this.riskButtonClick.emit(e);
    } else if (imageType=='statementButton') {
      this.statementButtonClick.emit(e);
    } else if (imageType=='undeleteButton') {
      if (this.undeleteButtonDisabled(e)===true)
        return;

      this.undeleteButtonClick.emit(e);
    }
  }

  private async refreshApiPathGet(): Promise<void> {
    try {
      if (this.apiPath?.refreshGet==undefined)
        return;

      await this.apiPath.refreshGet();

      this.gridViewService.apiPathGet=this.apiPath?.get;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setupServerSideProcessingStore() {
    try {
      const isNotEmpty = (value: unknown) => value !== undefined && value !== null && value !== '';
      
      this.serverSideDataSource = new DataSource({
        store: new CustomStore({
          key: "id",
          load: async (loadOptions: LoadOptions) => {
            //CRN_20260804 - Grids need signed token refresh
            await this.refreshApiPathGet();

            let params: HttpParams = new HttpParams();
            [
              'filter',
              'group',
              'groupSummary',
              'parentIds',
              'requireGroupCount',
              'requireTotalCount',
              'searchExpr',
              'searchOperation',
              'searchValue',
              'select',
              'sort',
              'skip',
              'take',
              'totalSummary',
              'userData',
            ]
            .forEach(function (i) {
              const optionValue = loadOptions[i as keyof LoadOptions];

              if (i in loadOptions && isNotEmpty(optionValue)) {
                //CRN_20260421 - DevExtreme pre-converts Date objects to "yyyy-MM-ddTHH:mm:ss.000"
                //               SQL Server cannot cast .000 milliseconds, so strip out
                params=params.set(i, JSON.stringify(optionValue, (_key, value) => {
                  if (typeof value==='string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+$/.test(value))
                    return value.replace(/\.\d+$/, '');
                  
                  return value;
                }));
              }
            });
            
            this.showContinuousLoadPanel();

            return lastValueFrom(
              this.httpClientService.get(this.apiPath?.get ?? "", { params })
            )
            .then((response: any) => {
              return {
                data      : response?.data,
                totalCount: response?.totalCount,
                summary   : response?.summary,
                groupCount: response?.groupCount,
              };
            })
            .catch((error) => {
              this.hideContinuousLoadPanelNow();
              const errorMessage=error?.message ?? error?.error?.message ?? error ?? "Data loading error";
              this.exceptionsService.handleException(new Error(errorMessage));

              return { data: [], totalCount: 0 };
            });
          },
          // For DevExtreme Popup Form
          // -------------------------
          // insert: (values) => {
          //   return lastValueFrom(this.httpClientService.post(this.apiPath?.post ?? "", this.anyDbObject))
          //          .catch((error) => {
          //           this.exceptionsService.handleStringException("Insertion failed - " + error);
          //         });
          // },
          // remove: (key) => {
          //   return lastValueFrom(this.httpClientService.delete((this.apiPath?.delete ?? "") + "/", key))
          //          .catch((error) => {
          //           this.exceptionsService.handleStringException("Deletion failed - " + error);
          //         });
          // },
          // update: (key, values) => {
          //   return lastValueFrom(this.httpClientService.put((this.apiPath?.put ?? "") + "/", key, this.anyDbObject))
          //          .catch((error) => {
          //           this.exceptionsService.handleStringException("Update failed - " + error);
          //         });
          // }
        }),
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public refreshData(refreshDropDownArrays?: boolean) {
    try {
      // if (refreshDropDownArrays) {
      //   this.gridViewService.populateDropdownDataArray(true);

      // } else {
        this._refreshData();
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private _refreshData() {
    try {
      if (this.dgProperties?.remoteOperations) {
        if (this.serverSideDataSource == null) {
          this.clientSideProcessingModels=[];
          this.setupServerSideProcessingStore();
        }
        else {
          this.dataGrid.instance.refresh();
        }
      } else {
        this.getDataForClientSideProcessing();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public repaintGrid() {
    try {
      this.dataGrid.instance.repaint();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setActionColumnWidth(value: number): void {
    try {
      const colCount=this.dataGrid.instance.columnCount();
      for (let i=0; i<colCount; i++) {
        if (this.dataGrid.instance.columnOption(i, 'type')==='buttons') {
          this.dataGrid.instance.columnOption(i, 'width', value);
          break;
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setColumnMinWidth(value: number | undefined, actionColumnWidth?: number): void {
    try {
      const horizontalScrollOn=value!=undefined && value>0;
      const modernOn          =this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridViewModernStyle, false);

      this.dataGrid.instance.beginUpdate();

      try {
        this.dataGrid.instance.option('columnMinWidth', value ?? 0);

        this.dataGrid.instance.option('columnHidingEnabled',     horizontalScrollOn ? false    : modernOn);
        this.dataGrid.instance.option('scrolling.showScrollbar', horizontalScrollOn ? 'always' : 'never' );

        const colCount=this.dataGrid.instance.columnCount();

        if (horizontalScrollOn) {
          for (let i=0; i<colCount; i++) {
            const current=this.dataGrid.instance.columnOption(i, 'hidingPriority');

            if (current!=undefined && this.dataGrid.instance.columnOption(i, 'cachedHidingPriority')==undefined) {
              this.dataGrid.instance.columnOption(i, 'cachedHidingPriority', current);
            }

            this.dataGrid.instance.columnOption(i, 'hidingPriority', undefined);
          }
        } else {
          for (let i=0; i<colCount; i++) {
            const cached=this.dataGrid.instance.columnOption(i, 'cachedHidingPriority');

            if (cached!=undefined) {
              this.dataGrid.instance.columnOption(i, 'hidingPriority', cached);
            }
          }
        }

        if (actionColumnWidth!=undefined) {
          for (let i=0; i<colCount; i++) {
            if (this.dataGrid.instance.columnOption(i, 'type')==='buttons') {
              this.dataGrid.instance.columnOption(i, 'minWidth', actionColumnWidth);
              this.dataGrid.instance.columnOption(i, 'width',    actionColumnWidth);
              break;
            }
          }
        }
      }
      finally {
        this.dataGrid.instance.endUpdate();
      }

      this.applyAdaptiveColumnVisibility();

      this.dataGrid.instance.updateDimensions();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshLayout(): void {
    try {
      this.dataGrid?.instance?.updateDimensions();
      this.applyAdaptiveColumnVisibility();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setColumnHidingEnabled(enabled: boolean): void {
    try {
      this.dataGrid.instance.option('columnHidingEnabled', enabled);
      this.dataGrid.instance.updateDimensions();
      this.applyAdaptiveColumnVisibility();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyAdaptiveColumnVisibility(): void {
    try {
      const columnMinWidth    =this.dataGrid.instance.option('columnMinWidth') as number | undefined;
      const horizontalScrollOn=columnMinWidth!=undefined && columnMinWidth>0;
      const shouldHideAdaptive=horizontalScrollOn;
      const hostElement       =this.elementRef.nativeElement as HTMLElement;

      if (shouldHideAdaptive) {
        this.renderer2.addClass(hostElement, "grid-view-hide-adaptive");
      } else {
        this.renderer2.removeClass(hostElement, "grid-view-hide-adaptive");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //RBW_20260527 - A column with fixed=true is pinned only while the grid is wider than its container.
  private applyResponsiveColumnFixing(): void {
    try {
      const instance=this.dataGrid?.instance;

      if (!instance)
        return;

      const flagged=(this.dgColumns ?? []).filter(c => c.fixed===true).map(c => c.dataField);

      if (flagged.length===0)
        return;

      const visibleColumns=<any[]>instance.getVisibleColumns();
      let   totalWidth    =0;

      for (const col of visibleColumns) {
        const width=typeof col.visibleWidth==="number" ? col.visibleWidth
                  : typeof col.width==="number"         ? col.width
                                                        : 0;
        totalWidth+=width;
      }

      const containerWidth=(<HTMLElement>instance.element()).clientWidth;
      const needsFixing   =totalWidth>containerWidth+2;
      const currentlyFixed=instance.columnOption(flagged[0], "fixed")===true;

      if (currentlyFixed===needsFixing)
        return;

      instance.beginUpdate();

      for (const dataField of flagged) {
        instance.columnOption(dataField, "fixed", needsFixing);
      }

      instance.endUpdate();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyCustomToolbarTooltips(gridElement: HTMLElement): void {
    try {
      const headerPanel=gridElement.querySelector('.dx-datagrid-header-panel') as HTMLElement | null;

      if (!headerPanel)
        return;

      const iconLabelMap: { [iconClass: string]: string }={
        'dx-icon-add'           : this.dgProperties?.addButtonHint ?? 'Add',
        'dx-icon-column-chooser': 'Column Chooser',
        'dx-icon-refresh'       : 'Refresh',
      };

      const tooltipsEnabled     =this.showTooltips;
      const elementsWithTitle   =headerPanel.querySelectorAll<HTMLElement>('[title]');

      elementsWithTitle.forEach(el => {
        const title=el.getAttribute('title');

        if (title!=null && title.length>0) {
          el.setAttribute('data-grid-tooltip', title);
          el.removeAttribute('title');
        }
      });

      Object.keys(iconLabelMap).forEach(iconClass => {
        const iconEls=headerPanel.querySelectorAll<HTMLElement>('.' + iconClass);

        iconEls.forEach(iconEl => {
          const toolbarItem=iconEl.closest<HTMLElement>('.dx-toolbar-item');

          if (toolbarItem)
            toolbarItem.setAttribute('data-grid-tooltip', iconLabelMap[iconClass]);

          const innerButton=iconEl.closest<HTMLElement>('.dx-button');

          if (innerButton && innerButton!==toolbarItem)
            innerButton.removeAttribute('data-grid-tooltip');
        });
      });

      const elementsWithCaptured=headerPanel.querySelectorAll<HTMLElement>('[data-grid-tooltip]');

      if (!tooltipsEnabled) {
        elementsWithCaptured.forEach(el => el.removeAttribute('data-grid-tooltip'));
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setGridHeight(height: number): void {
    try {
      this.dataGrid.instance.option('height', height);
      this.dataGrid.instance.updateDimensions();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Save/Delete Data

  public saveData(newRow: boolean) {
    try {
      const savedRow=this.anyDbObject;

      this.gridViewService.save(this.anyDbObject)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.refreshData();
          this.resetForm(true);
          this.dataHasBeenSaved.emit(savedRow);
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
          this.refreshData();
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public deleteData(id: any) {
    try {
      const deletedRow=this.deleteRowData;

      this.gridViewService.delete(id)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.refreshData();
          this.dataHasBeenDeleted.emit(deletedRow);
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
          this.refreshData();
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public getValidationRuleMessage(dgColumnValidation: DgColumnValidation): string {
    try {
      switch(dgColumnValidation.rule) { 
        case DgFormValidationRule.async: {
           return "Async value required";
        }
        case DgFormValidationRule.compare: {
          return "Compare value required";
        }
        case DgFormValidationRule.custom: {
          return "Custom value required";
        }
        case DgFormValidationRule.email: {
          return "Email format required";
        }
        case DgFormValidationRule.numeric: {
          return "Numeric value required";
        }
        case DgFormValidationRule.pattern: {
          return "Pattern format required";
        }
        case DgFormValidationRule.range: {
          return "Range value required";
        }
        case DgFormValidationRule.required: {
          return "A value is required";
        }
        case DgFormValidationRule.stringLength: {
          let message="Text length must be";

          if (dgColumnValidation.min != undefined &&
              dgColumnValidation.max != undefined &&
              dgColumnValidation.min == dgColumnValidation.max) {
            message+=` ${dgColumnValidation.min} characters`;

            return message;
          }

          if (dgColumnValidation.min != undefined) {
            message+=` ${dgColumnValidation.min} characters minimum`;
          }

          if (dgColumnValidation.min != undefined && dgColumnValidation.max != undefined) {
            message+=" and";
          }

          if (dgColumnValidation.max != undefined) {
            message+=` ${dgColumnValidation.max} characters maximum`;
          }

          return message;
        }
        default: {
          return "A value is required";
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "A value is required";
    }
  }

  //#region Toolbar

  public onCellClick(e : any) {
    try {
      if (e?.column?.index != undefined && e.column.index > -1 && e.column.index < (this.dgColumns?.length ?? -1)) {
        if(e.rowType=="header"){
          var sortOrder=e.column.sortOrder;

          if(sortOrder==undefined && e.column.allowSorting !== false) {
                e.component.columnOption(e.column.index, "sortOrder", "asc");
          }
        } else if (e.rowType!="filter"){
          const templateType=this.dgColumns![e.column.index].cellTemplateType;

          if (templateType != undefined &&
              (templateType=="link" || templateType=="iconButton" || templateType=="avatar") &&
              this.dgColumns![e.column.index].cellTemplateCondition(e.data) == true) {
            this.cellClick.emit(e);
          }
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onContentReady(e: any) {
    try {
      const gridElement: HTMLElement=e.element as HTMLElement;

      this.waitForHeaderRow(gridElement, 0);
      this.contentReady.emit(e);

      this.maybeHideContinuousLoadPanel(e.component);

      this.applyAdaptiveColumnVisibility();
      this.applyResponsiveColumnFixing();
      this.applyCustomToolbarTooltips(gridElement);
      this.evaluateUserDefinedColumns();

      if (!this.dgProperties?.skipStickyLayout) {
        this.applyStickyGridHeaders();
        this.applyStickyGridPager();
      }

      if (this.hasColouredRow && !this.pendingDimensionsFix) {
        this.pendingDimensionsFix=true;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            try {
              this.dataGrid?.instance?.updateDimensions();
            }
            catch(e) {
              this.exceptionsService.handleException(<Error>e);
            }
            finally {
              this.pendingDimensionsFix=false;
            }
          });
        });
      }

      this.hasColouredRow=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onContextMenuPreparing=(e: DxDataGridTypes.ContextMenuPreparingEvent) => {
    try {
      (e as any).event!.preventDefault();

      if (this.dgProperties!.rowRightClickEmitOnly) {
        this.rowRightClick.emit(e);
        return;
      }

      if (this.dgPopup!.overridePopup) {
        this.rowRightClick.emit(e);
      } else {
        //Not Implemented
      }

      if (this.gridAllowCopyCellValue) {
        if (e.target==="header" && e.row?.rowType==="header" && e.column) {
          const headerText=this.cleanHeaderCaption(e.column.caption);

          if (!headerText)
            return;

          e.items=e.items ?? [];

          e.items.push({
            beginGroup : true,
            text       : "Copy to clipboard",
            onItemClick: () => { this.copyToClipboard(headerText); }
          });

          return;
        }

        if (e.target !== "content" || e.row?.rowType !== "data" || !e.column)
          return;

        const rawVal=((e as any).value ?? e.row?.data?.[e.column.dataField as string])?.toString().trim();

        if (!rawVal)
          return;

        e.items=e.items ?? [];

        e.items.push({
          text: "Copy to clipboard",
          onItemClick: () => { this.copyToClipboard(rawVal); }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  };

  private cleanHeaderCaption(caption: string | undefined): string {
    try {
      if (!caption)
        return "";

      return caption.replace(/[^\p{L}\p{N}\s\-_.,()/&]/gu, "").trim();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return caption ?? "";
    }
  }

  private copyToClipboard(text: string): void {
    try {
      const fallback=(value: string) => {
        const textarea         =document.createElement("textarea");
        textarea.value         =value;
        textarea.style.position="fixed";
        textarea.style.opacity ="0";

        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      };

      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(text).catch(() => fallback(text));

      } else {
        fallback(text);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onToolbarPreparing(event: any) {
    try {
      if (this.dgProperties!.showRefreshButton) {
        const toolbarItems = event.toolbarOptions.items;

        // Add a custom "Refresh" button
        toolbarItems.unshift({
          widget: 'dxButton',
          options: {
            hint: 'Refresh',
            icon: 'refresh',
            //icon : "assets/images/_suresim/Button Add 68x37.png",
            //text : DxText.add,
            //type : DxType.success,
            //width: 100,
            onClick: () => {
              this.refreshClick.emit();
              this._refreshData();
              //this.dataGrid.instance.refresh();
            },
          },
          location: 'after',
        });
      }

      if (this.dgProperties?.button1Options != undefined)
      {
        const toolbarItems = event.toolbarOptions.items;
        toolbarItems.unshift({
          widget: 'dxButton',
          options: this.dgProperties?.button1Options,
          location: 'after',
        });
      }

      if (!this.dgProperties!.useDevExtremePopupForm) {
        const toolbarItems = event.toolbarOptions.items;

        // Remove the default "Add" button if it exists
        const addButtonIndex = toolbarItems.findIndex(
          (item: any) => item.name === 'addRowButton'
        );

        if (addButtonIndex > -1) {
          toolbarItems.splice(addButtonIndex, 1);
        }

        // Add a custom "Add" button
        if (this.dgProperties!.showAddButton)
        {
          toolbarItems.unshift({
            widget: 'dxButton',
            options: {
              hint: this.dgProperties!.addButtonHint ?? 'Add',
              icon: DxIcon.add,
              //icon : "assets/images/_suresim/Button Add 68x37.png",
              //text : DxText.add,
              //type : DxType.success,
              //width: 100,
              onClick: () => {
                this.onAddButtonClick(event);
              },
            },
            location: 'after',
          });
        }
      }

      const allToolbarItems=event.toolbarOptions.items;

      const dxAddRowButton=allToolbarItems.find((item: any) => item.name==='addRowButton');
      if (dxAddRowButton) {
        dxAddRowButton.options={ ...(dxAddRowButton.options ?? {}), hint: this.dgProperties?.addButtonHint ?? 'Add' };
      }

      const columnChooserButton=allToolbarItems.find((item: any) => item.name==='columnChooserButton');
      if (columnChooserButton) {
        columnChooserButton.options={ ...(columnChooserButton.options ?? {}), hint: 'Column Chooser' };
      }

      const exportButton=allToolbarItems.find((item: any) => item.name==='exportButton');

      if (exportButton) {
        const allowSelected=this.dgProperties?.allowExportSelectedData===true;

        const exportItems: Array<{ text: string; format: string; selectedRowsOnly: boolean }>=[
          { text: 'PDF - All data',        format: DgExportFormat.pdf,  selectedRowsOnly: false },
          { text: 'PDF - Selected Rows',   format: DgExportFormat.pdf,  selectedRowsOnly: true  },
          { text: 'Excel - All data',      format: DgExportFormat.xlsx, selectedRowsOnly: false },
          { text: 'Excel - Selected Rows', format: DgExportFormat.xlsx, selectedRowsOnly: true  },
        ].filter(item => allowSelected || !item.selectedRowsOnly);

        exportButton.widget ='dxDropDownButton';
        exportButton.options={
          displayExpr    : 'text',
          dropDownOptions: { showTitle: true, title: 'Export', width: 200 },
          hint           : 'Export',
          icon           : 'export',
          items          : exportItems,
          keyExpr        : 'text',
          showArrowIcon  : true,
          stylingMode    : 'text',
          onItemClick    : (e: any) => {
            this.onExporting(<any>{
              component       : this.dataGrid.instance,
              format          : e.itemData.format,
              selectedRowsOnly: e.itemData.selectedRowsOnly
            });
          },
        };
      }

      if (this.hasAdditionalFilters) {
        const toolbarItems=event.toolbarOptions.items;

        toolbarItems.unshift({
          cssClass: 'gv-toolbar-hideable',
          location: 'after',
          template: 'additionalFiltersTemplate',
        });
      }

      if (this.dgProperties?.filterRow) {
        const toolbarItems=event.toolbarOptions.items;

        toolbarItems.unshift({
          cssClass: 'gv-toolbar-hideable',
          location: 'after',
          template: 'filterRowToggleTemplate',
        });
      }

      if (this.gridRememberColumns) {
        const toolbarItems=event.toolbarOptions.items;

        toolbarItems.unshift({
          cssClass: 'gv-toolbar-hideable',
          location: 'after',
          template: 'userDefinedColumnsTemplate',
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public applyShowOnlyView(models: any[]): any[] {
    try {
      const showCeased =this.showCeasedFilters && this.additionalFilters.onlyCeased;
      const showDeleted=this.showDeletedToggle && this.additionalFilters.onlyDeleted;

      if (!showCeased && !showDeleted)
        return models ?? [];

      return (models ?? []).filter(x => (showCeased  && (x?.ceased===true || x?.companyCeased===true)) ||
                                        (showDeleted && x?.deleted===true));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return models;
    }
  }

  private onAddButtonClick(event: any) {
    try {
      if (this.dgPopup!.overridePopup) {
        this.addButtonClick.emit(event);
      } else {
        this.openFormToAdd();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Override Edit and Delete onClick Events
  
  public editRow = (e: DxDataGridTypes.ColumnButtonClickEvent) => {
    try {
      e.event!.preventDefault();

      if (this.dgPopup!.overridePopup) {
        this.editButtonClick.emit(e);
      } else {
        let rowData={...e.row!.data};
        this.openFormToEdit(rowData);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  };
  
  public deleteRow = (e: DxDataGridTypes.ColumnButtonClickEvent) => {
    try {
      e.event!.preventDefault();

      if (this.dgActionColumn?.deleteRowButtonCondition(e.row!.data)===false)
        return;

      if (this.deleteButtonDisabled(e)===true)
        return;

      if (this.dgActionColumn!.overrideDelete) {
        this.deleteButtonClick.emit(e);
      } else {
        let rowData={...e.row!.data};
        this.confirmDelete(rowData);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  };

  public undeleteButtonVisible=(e: any): boolean => {
    try {
      return this.dgActionColumn?.undeleteRowButtonCondition(e?.row?.data)===true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  };

  public undeleteDeleteButtonVisible=(e: any): boolean => {
    try {
      if (!this.dgActionColumn?.allowUndelete)
        return true;

      return this.dgActionColumn?.undeleteRowButtonCondition(e?.row?.data)!==true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  };

  public deleteButtonVisible=(e: any): boolean => {
    try {
      if (this.undeleteDeleteButtonVisible(e)!==true)
        return false;

      const condition=this.dgActionColumn?.deleteRowButtonCondition;

      if (typeof condition !== 'function')
        return true;

      return condition(e?.row?.data)===true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  };
  
  public updateButtonVisible=(e: any): boolean => {
    try {
      const condition=this.dgActionColumn?.updateRowButtonCondition;

      if (typeof condition !== 'function')
        return true;

      return condition(e?.row?.data)===true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  };

  public moreButtonVisible=(e: any): boolean => {
    try {
      const condition=this.dgActionColumn?.moreRowButtonCondition;

      if (typeof condition !== 'function')
        return true;

      return condition(e?.row?.data)===true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  };

  public undeleteRow=(e: DxDataGridTypes.ColumnButtonClickEvent) => {
    try {
      e.event!.preventDefault();

      if (this.undeleteButtonDisabled(e)===true)
        return;

      this.undeleteButtonClick.emit(e);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  };

  public undeleteButtonDisabled=(e: any): boolean => {
    try {
      const condition=this.dgActionColumn?.undeleteRowButtonDisabledCondition;

      if (typeof condition !== 'function')
        return false;

      return condition(e?.row?.data)===true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public undeleteButtonHint=(e: any): string => {
    try {
      if (!this.undeleteButtonDisabled(e))
        return "";

      const perRowHint=this.dgActionColumn?.undeleteRowButtonHint;

      if (typeof perRowHint==='function')
        return perRowHint(e?.row?.data) ?? "";

      return this.dgActionColumn?.undeleteButtonDisabledHint ?? "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public deleteButtonDisabled=(e: any): boolean => {
    try {
      const condition=this.dgActionColumn?.deleteRowButtonDisabledCondition;

      if (typeof condition !== 'function')
        return false;

      return condition(e?.row?.data)===true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public deleteButtonHint=(e: any): string => {
    try {
      if (!this.deleteButtonDisabled(e))
        return "";

      const perRowHint=this.dgActionColumn?.deleteRowButtonHint;

      if (typeof perRowHint==='function')
        return perRowHint(e?.row?.data) ?? "";

      return this.dgActionColumn?.deleteButtonDisabledHint ?? "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public confirmDelete(rowData: any) {
    try {
      this.deleteId     =rowData["id"];
      this.deleteRowData=rowData;
      this.modalService.open(this.deleteModalTemplate, { backdrop: this.modalBackGround,
                                                         centered: true,
                                                         keyboard: false });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public moreRow = (e: DxDataGridTypes.ColumnButtonClickEvent) => {
    try {
      e.event!.preventDefault();

      if (this.dgPopup!.overridePopup) {
        this.moreButtonClick.emit(e);
      } else {
        //Not Implemented
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public riskRow = (e: DxDataGridTypes.ColumnButtonClickEvent) => {
    try {
      e.event!.preventDefault();
      this.riskButtonClick.emit(e);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public riskButtonVisible = (e: any): boolean => {
    try {
      if (!this.dgActionColumn?.allowRisk)
        return false;

      const condition=this.dgActionColumn?.riskRowButtonCondition;

      if (typeof condition !== 'function')
        return true;

      return condition(e?.row?.data) === true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public riskButtonHidden = (e: any): boolean => {
    try {
      if (!this.dgActionColumn?.allowRisk)
        return false;

      return this.riskButtonVisible(e) === false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  };

  public locationRow=(e: DxDataGridTypes.ColumnButtonClickEvent) => {
    try {
      e.event!.preventDefault();
      this.locationButtonClick.emit(e);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public locationButtonVisible=(e: any): boolean => {
    try {
      if (!this.dgActionColumn?.allowLocation)
        return false;

      const condition=this.dgActionColumn?.locationRowButtonCondition;

      if (typeof condition !== 'function')
        return true;

      return condition(e?.row?.data)===true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public locationButtonHidden=(e: any): boolean => {
    try {
      if (!this.dgActionColumn?.allowLocation)
        return false;

      return this.locationButtonVisible(e)===false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  };

  public messageRow=(e: DxDataGridTypes.ColumnButtonClickEvent) => {
    try {
      e.event!.preventDefault();
      this.messageButtonClick.emit(e);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public messageButtonVisible=(e: any): boolean => {
    try {
      if (!this.dgActionColumn?.allowMessage)
        return false;

      const condition=this.dgActionColumn?.messageRowButtonCondition;

      if (typeof condition !== 'function')
        return true;

      return condition(e?.row?.data)===true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public messageButtonHidden=(e: any): boolean => {
    try {
      if (!this.dgActionColumn?.allowMessage)
        return false;

      return this.messageButtonVisible(e)===false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  };

  public statementRow=(e: DxDataGridTypes.ColumnButtonClickEvent) => {
    try {
      e.event!.preventDefault();
      this.statementButtonClick.emit(e);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public statementButtonVisible=(e: any): boolean => {
    try {
      if (!this.dgActionColumn?.allowStatement)
        return false;

      const condition=this.dgActionColumn?.statementRowButtonCondition;

      if (typeof condition !== 'function')
        return true;

      return condition(e?.row?.data) === true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public statementButtonHidden=(e: any): boolean => {
    try {
      if (!this.dgActionColumn?.allowStatement)
        return false;

      return this.statementButtonVisible(e) === false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  };

  //#endregion

  //#region Row Events

  public onExporting(event: ExportingEvent) {
    try {
      let filename        =formatDate(Date.now(), "yyyyMMdd HHmmss ", "en-GB")+this.dgProperties?.exportFilenameSuffix;
      let selectedRowsOnly=(<any>event).selectedRowsOnly===true;

      if (event.format==DgExportFormat.pdf) {
        const doc = new jsPDF();
        exportDataGridToPdf({
            jsPDFDocument   : doc,
            component       : this.dataGrid.instance,
            selectedRowsOnly: selectedRowsOnly
        }).then(() => {
            doc.save(filename + ".pdf");
        })
      } else if (event.format==DgExportFormat.xlsx) {
        const workbook  = new Workbook();
        const worksheet = workbook.addWorksheet("Sheet1");
        exportDataGrid({
          component       : event.component,
          worksheet       : worksheet,
          selectedRowsOnly: selectedRowsOnly,
          customizeCell   : function(options) {
            options.excelCell.font     ={ name: "Arial", size: 12 };
            options.excelCell.alignment={ horizontal: "left" };
          }
        })
        .then(function() {
          workbook.xlsx.writeBuffer()
          .then(function(buffer: BlobPart) {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), filename + ".xlsx");
          });
        });
      } else {
        throw new Error(`Grid-View: Export Format not Implemented (${event.format})`);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public onReorder = (e: DxDataGridTypes.RowDraggingReorderEvent) => {
    try {
      if (this.checkInjectedData()) {
        const visibleRows = e.component.getVisibleRows();
        const toIndex     = this.clientSideProcessingModels.findIndex((item) => item.id===visibleRows[e.toIndex].data.id);
        const fromIndex   = this.clientSideProcessingModels.findIndex((item) => item.id===e.itemData.id);
    
        this.clientSideProcessingModels.splice(fromIndex, 1);
        this.clientSideProcessingModels.splice(toIndex, 0, e.itemData);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  };

  public onEditingStart(event: any) {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onEditorPreparing(event: any) {
    try {
      if (event.parentType==='filterRow') { //&& event.editorName == 'dxSelectBox')
        //event.editorName="dxTextBox";
        
        const dgColumn=this.dgColumns?.find(x => x.dataField===event.dataField);
        
        if (dgColumn?.filterPlaceholder)
          event.editorOptions.placeholder=dgColumn.filterPlaceholder;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onInitNewRow(event: any) {
    try {
      // For DevExtreme Popup Form
      // -------------------------
      // let anyDbObjectStr   ="";
      // let dataType: string ="";
      // let dbField : string ="";
      // let value   : boolean | string | number;
  
      // for(var i=0; i<this.dgColumns!.length; i++) {
      //   if (this.dgColumns![i].sendToDB) {
      //     dataType=this.dgColumns![i].dataType;
      //     dbField =this.dgColumns![i].dataField;
      //     value   =this.dgColumns![i].value ?? "";
          
      //     if (this.dgColumns![i].valueAddOnInitNewRow) {
      //       event.data[dbField]=value;
      //     }

      //     if (anyDbObjectStr!="") {
      //       anyDbObjectStr+=",";
      //     }
            
      //     if (dataType=="boolean" || dataType=="number") {
      //       anyDbObjectStr += `"${dbField}":${value}`;
      //     } else {
      //       anyDbObjectStr += `"${dbField}":"${value}"`;
      //     }
      //   }
      // }
  
      // this.anyDbObject = JSON.parse("{"+anyDbObjectStr+"}");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onRowClick(event: any) {
    try {
      if (this.rowClickTimer)
        return;

      this.rowClickTimer=setTimeout(() => {

        let   rowId         =-1;
        const clickedElement=event.event.target; // DOM element clicked
        const columnIndex   = Array.from(event.component.getVisibleColumns()).findIndex((col: any) => {
                                return clickedElement.closest(`td[aria-colindex="${col.index + 1}"]`);
                              });

        if (this.dgProperties?.focusedRowUnselect && !this.selectionChangedRaised && columnIndex > -1) {  
          var dataGrid=event.component;  
          var keys    =dataGrid.getSelectedRowKeys();  
          dataGrid.deselectRows(keys);  
          this.dataGrid.instance.option('focusedRowIndex', -1);
        } else {
        
          if (event != undefined && event.data != undefined && event.data["id"] != undefined)
            rowId=event.data["id"];
        }
        
        this.selectionChangedRaised = false; 
        
        this.rowClick.emit(rowId);
        this.rowClickTimer=null;

      }, this.gridRowClickTimerMilliSecs);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onRowDblClick(event: any) {
    try {
      if (this.rowClickTimer) {
        clearTimeout(this.rowClickTimer);
        this.rowClickTimer=null;
      }

      let rowId=-1;

      if (event != undefined && event.data != undefined && event.data["id"] != undefined)
        rowId=event.data["id"];

      this.rowDblClick.emit(rowId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onRowExpanding(event: any) {
    try {
      event.component.collapseAll(-1);
      this.rowExpanding.emit(event.key);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public onRowInserting(event: any) {
    try {
      // For DevExtreme Popup Form
      // -------------------------
      // let changesObject=event.data;
      // let dbField      ="";
        
      // for(var i=0; i<this.dgColumns!.length; i++) {
      //   dbField=this.dgColumns![i].dataField;
          
      //   if (changesObject[dbField]) {
      //     this.anyDbObject[dbField]=changesObject[dbField];
      //   }
      // }
      
      // if (!this.dgProperties?.remoteOperations) {
      //   this.saveData(true);
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      event.cancel=true;
    }
  }

  public onRowInserted(event: any) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onCellPrepared(event: any) {
    try {
      if (event.rowType==='data' && event.column?.dataField) {
        const dgColumn = this.dgColumns?.find(column => column.dataField === event.column.dataField);

        const validationFields = (dgColumn?.validationFields && dgColumn.validationFields.length > 0)
                                 ? dgColumn.validationFields
                                 : [event.column.dataField];
        const cellMessages: string[] = [];

        if (event.data?.invalidFields) {
          for (const field of validationFields) {
            const messages = event.data.invalidFields[field];

            if (Array.isArray(messages))
              cellMessages.push(...messages);
          }
        }

        const isInvalid = cellMessages.length > 0;
        const isGreyed  = !!(dgColumn?.greyCellWhen && dgColumn.greyCellWhen(event.data));

        isInvalid ? event.cellElement.classList.add('gv-cell-invalid') : event.cellElement.classList.remove('gv-cell-invalid');
        isGreyed  ? event.cellElement.classList.add('gv-cell-greyed')  : event.cellElement.classList.remove('gv-cell-greyed');

        if (isInvalid) {
          event.cellElement.setAttribute('title', cellMessages.join('\n'));
        } else if (isGreyed && dgColumn?.greyCellTitle) {
          event.cellElement.setAttribute('title', dgColumn.greyCellTitle(event.data) ?? '');
        } else if (dgColumn?.cellTitle) {
          event.cellElement.setAttribute('title', dgColumn.cellTitle(event.data) ?? '');
        } else if (dgColumn?.greyCellTitle) {
          //RBW_20260814 - fall back to the cell's own text so the tooltip still works and no stale reason lingers
          event.cellElement.setAttribute('title', event.text ?? '');
        }
      }

      if (event.rowType!=='data' || (event.command!=='edit' && event.column?.type!=='buttons'))
        return;

      //CRN_20260804 - Keep the tooltip on Delete only
      event.cellElement.removeAttribute('title');

      const deleteIcon   =this.dgActionColumn?.deleteIcon;
      const undeleteIcon =this.dgActionColumn?.undeleteIcon;
      const deleteImage  =deleteIcon
                          ? <HTMLElement | null>event.cellElement?.querySelector('img[src*="' + deleteIcon + '"]')
                          : null;
      const undeleteImage=(!deleteImage && undeleteIcon)
                          ? <HTMLElement | null>event.cellElement?.querySelector('img[src*="' + undeleteIcon + '"]')
                          : null;
      const hintImage    =deleteImage ?? undeleteImage;

      if (!hintImage)
        return;

      if (hintImage.classList.contains('has-ngb-tooltip')) {
        hintImage.removeAttribute('title');
        return;
      }

      const hint=deleteImage
                 ? this.deleteButtonHint({ row: { data: event.data } })
                 : this.undeleteButtonHint({ row: { data: event.data } });

      hintImage.removeAttribute('title');

      const existingHost=hintImage.parentElement?.classList.contains('grid-hint-host')
                         ? hintImage.parentElement
                         : null;

      if (!hint) {
        existingHost?.removeAttribute('data-grid-hint');
        return;
      }

      let host=existingHost;

      if (!host) {
        host=this.renderer2.createElement('span');
        this.renderer2.addClass(host, 'grid-hint-host');
        hintImage.parentNode?.insertBefore(host!, hintImage);
        this.renderer2.appendChild(host, hintImage);
      }

      this.renderer2.setAttribute(host, 'data-grid-hint', hint);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onRowPrepared(event: any) {
    try {
      if (event.rowType==='data') {
        if (event.data.backgroundColor) {
          event.rowElement.style.backgroundColor=event.data.backgroundColor;
          this.hasColouredRow=true;
        
        } else if (event.data.deleted===true) {
          event.rowElement.style.backgroundColor=OurColors.LightRed;
          this.hasColouredRow                   =true;

        } else if (event.data.ceased===true || event.data.companyCeased===true) {
          event.rowElement.style.backgroundColor=OurColors.LightGrey;
          this.hasColouredRow                   =true;
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public onRowUpdating(event: any) {
    try {
      // For DevExtreme Popup Form
      // -------------------------
      // this.anyDbObject  =event.oldData;
      // let changesObject =event.newData;
      // let dbField       ="";
        
      // for(var i=0; i<this.dgColumns!.length; i++) {
      //   dbField=this.dgColumns![i].dataField;
          
      //   if (changesObject[dbField] != undefined) {
      //     this.anyDbObject[dbField]=changesObject[dbField];
      //   }
      // }

      // if (!this.dgProperties?.remoteOperations) {
      //   this.saveData(false);
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      event.cancel=true;
    }
  }

  public onRowUpdated(event: any) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public onRowRemoving(event: any) {
    try {
      // For DevExtreme Popup Form
      // -------------------------
      // if (!this.dgProperties?.remoteOperations && event.data["id"]) {
      //   this.deleteData(event.data["id"]);
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      event.cancel=true;
    }
  }

  public onRowRemoved(event: any) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onSelectionChanged(event: any) {
    try {
      this.selectionChangedRaised = true;

      this.selectionChanged.emit(<any[]>(event?.selectedRowsData ?? []));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onTabChange(event: any) {
    try {
      this.tabChanged.emit(event);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
  
  //#region Non-DevExtreme Popup Form

  get formData() {
    return this.addOrEditForm.controls;
  }

  private setupNonDevExtremeForm() {
    try {
      this.gridViewService.populateDropdownDataArray();
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.addOrEditForm = this.formBuilder.group({
      });

      this.addFormFields();
   }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormFields() {
    try {
      for (let column of this.dgColumns!) {
        if (column.formEnabled) {
          this.addOrEditForm.addControl(column.dataField, new FormControl(column.value, column.validators));
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields() {
    try {
      for (let column of this.dgColumns!) {
        if (column.formEnabled) {
          if (column.dataType == 'date' && column.ourDate != undefined)
          {
            column.ourDate = undefined;
          }
          this.addOrEditForm.removeControl(column.dataField);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openFormToAdd() {
    try {
      this.addNewRecord =true;
      this.formSubmitted=false;
      this.resetForm(false);
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openFormToEdit(rowData: any) {
    try {
      this.addNewRecord =false;
      this.formSubmitted=false;
      this.rowEditStarted.emit(rowData);
      this.openModal();

      let filteredRow;

      if (!this.dgProperties?.remoteOperations) {
        filteredRow=this.clientSideProcessingModels.filter((data: { id: any; }) => data.id === rowData["id"]);
      }

      for (let column of this.dgColumns!) {
        if (column.formEnabled) {
          if (this.dgProperties?.remoteOperations) {
            this.addOrEditForm.controls[column.dataField].setValue(rowData[column.dataField]);
          } else {
            this.addOrEditForm.controls[column.dataField].setValue(filteredRow![0][column.dataField]);
          }
        }
        if (column.readOnly)
        {
          this.addOrEditForm.controls[column.dataField].disable();
        }
        if (column.dataType == "date")
        {
          if (rowData[column.dataField] != undefined)
          {
            column.ourDate = populateOurDate(this.exceptionsService, rowData[column.dataField]);
          }
          else
          {
            column.ourDate = undefined;
          }
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal() {
    try {
      this.modalTemplateRef=this.modalService.open(this.modalTemplate, { backdrop: this.modalBackGround,
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Medium });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //CRN_20260114 - Original saveFormData()
  // public saveFormData() {
  //   try {
  //     this.formSubmitted=true;
  //     let anyDbObjectStr="";
  //     let dataType      ="";
  //     let dbField       ="";
  //     let formValue     ="";

  //     if (this.addOrEditForm.valid) {
  //       for(var i=0; i<this.dgColumns!.length; i++) {
  //         if (this.dgColumns![i].sendToDB) {
  //           dataType =this.dgColumns![i].dataType;
  //           dbField  =this.dgColumns![i].dataField;
  //           formValue=this.addOrEditForm.get(dbField)?.value;
            
  //           if (anyDbObjectStr!="") {
  //             anyDbObjectStr+=",";
  //           }
            
  //           if (dataType=="number" || dataType=="boolean" || formValue=="null" || formValue==null) {
  //             anyDbObjectStr += `"${dbField}":${formValue}`;
  //           } else {
  //             anyDbObjectStr += `"${dbField}":"${formValue}"`;
  //           }
  //         }
  //       }

  //       this.anyDbObject = JSON.parse("{"+anyDbObjectStr+"}");

  //       this.saveData(this.addNewRecord);
  //     }
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }
  
  public saveFormData() {
    try {
      this.formSubmitted=true;

      //RBW_20260120-If any of the validation routines check multiple fields you need to recheck each fields validation
      for (let column of this.dgColumns!) {
        if (column.formEnabled) {
          this.addOrEditForm.controls[column.dataField].updateValueAndValidity();
        }
      }

      if (this.addOrEditForm.valid) {

        let anyDbObject: any={};

        for (var i = 0; i < this.dgColumns!.length; i++) {
          if (this.dgColumns![i].sendToDB) {

            let dataType =this.dgColumns![i].dataType;
            let dbField  =this.dgColumns![i].dataField;
            let formValue=this.addOrEditForm.get(dbField)?.value;

            if (dataType=="number") {
              anyDbObject[dbField]=formValue != null ? Number(formValue) : null;
            
            } else if (dataType=="boolean") {
              anyDbObject[dbField]=formValue===true || formValue==="true";
            
            } else if (formValue==="null") {
              anyDbObject[dbField]=null;
            
            } else {
              anyDbObject[dbField]=formValue;
            }
          }
        }

        this.anyDbObject=anyDbObject;

        this.saveData(this.addNewRecord);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetForm(closingForm: boolean) {
    try {
      if (closingForm) {
        this.modalTemplateRef.close();

      } else {
        this.removeFormFields();
        this.addFormFields();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public clearData(): void {
    try {
      this.allFetchedModels          =[];
      this.clientSideProcessingModels=[];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Datalist
  public clearDataList(field:DgColumn): void {
    this.addOrEditForm.controls[field.dataField].setValue('');
  }

  public onSelect(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.blur(); // Removes focus from the input
  }
  //#endregion
  
  public getDropdownDataObjectArray(fieldName: string) {
    try {
      return this.gridViewService.getDropdownDataObjectArray(fieldName);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  public dateSelectionChanged(newDate: OurDate, fieldName: string) {
    try {
      this.addOrEditForm.controls[fieldName].setValue(formatDate(newDate.date,'yyyy-MM-ddTHH:mm:ss', "en-GB", "UTC"));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public dateSelectionCleared(fieldName: string) {
    try {
      this.addOrEditForm.controls[fieldName].setValue(null);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Date precision

  private datePrecisionDefault(param: string): string {
    try {
      return (<{ [key: string]: number | boolean | string }>ConfigSystemParamDefaults)[param] as string ?? eDatePrecision.DayMonthYear;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return eDatePrecision.DayMonthYear;
    }
  }

  public dateFormat(field: DgColumn): string {
    try {
      return "d/m/Y";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "d/m/Y";
    }
  }

  public monthSelector(field: DgColumn): boolean {
    try {
      return !!field.datePrecisionParam
             && this.datePrecisionService.getPrecision(field.datePrecisionParam, this.datePrecisionDefault(field.datePrecisionParam))===eDatePrecision.MonthYear;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public yearSelector(field: DgColumn): boolean {
    try {
      return !!field.datePrecisionParam
             && this.datePrecisionService.getPrecision(field.datePrecisionParam, this.datePrecisionDefault(field.datePrecisionParam))===eDatePrecision.Year;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //#endregion

  //#endregion

  public onDropdownChange(event: any, dataField: string) {
    try {
      let value: any;

      if (event?.target !== undefined) {
        let _value: null | string | undefined=(event.target as HTMLSelectElement)?.value;

        if (_value && typeof _value==="string") {
          _value=_value.includes(":") ? _value.split(":").pop()?.trim() : _value;
          
          value =!isNaN(Number(_value)) && _value !== "" ? Number(_value) : _value;
        }
      } else {
        value=event?.id ?? event;
      }

      if (value !== undefined && value !== null)
        this.dropdownChanged.emit({ dataField: dataField, value: value });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
  
  private waitForHeaderRow(gridElement: HTMLElement, attempts: number): void {
    try {
      if (this.gridViewModernStyle)
        return;

      const headerRow=gridElement.querySelector(".dx-datagrid-headers.dx-datagrid-nowrap");

      if (headerRow) {
        const bgColour  =this.gridSureSimBlue ? "rgb(85, 99, 160)" : "rgb(250, 250, 250)";
        const textColour=this.gridSureSimBlue ? "white"              : "black";
    
        this.renderer2.setStyle(headerRow, "background-color", bgColour);
        this.renderer2.setStyle(headerRow, "color", textColour);
    
        const headerCells=headerRow.querySelectorAll(".dx-header-row td");

        headerCells.forEach(cell => {
          this.renderer2.setStyle(cell, "background-color", bgColour);
          this.renderer2.setStyle(cell, "color", textColour);
        });
    
        const textSpans=headerRow.querySelectorAll(".dx-datagrid-text-content");

        textSpans.forEach(span => {
          this.renderer2.setStyle(span, "color", textColour);
        });
  
        const filterIcons=headerRow.querySelectorAll(".dx-header-filter");
  
        filterIcons.forEach(icon => {
          if (this.gridSureSimBlue) {
            this.renderer2.setStyle(icon, "filter", "brightness(0) invert(1)");
          } else {
            this.renderer2.removeStyle(icon, "filter");
          }
        });
    
      } else if (attempts<10) {
        setTimeout(() => this.waitForHeaderRow(gridElement, attempts+1), 100);

      } else {
        console.warn("Header row not found after 1s");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  // #region Debug Methods
  //20251006 RBW - Add this to an if statement within the html to see the value within the console window. e.g. @if (logValue(column!.caption, column!.cellTemplate ?? "") && column!.cellTemplate != undefined) {
  public logValue(tag: string, value: string) : boolean {
    console.log(tag + ' : ' + value);
    return true;
  }
  // #endregion
}
